import { Venue, VenuePinType } from "../types/venue";

export const getPinIcon = (business: Venue) => {
  let icon = VenuePinType.Grey;

  if (business.reviewsDetailsSubmitted > 0) {
    icon = VenuePinType.Orange;
  }
  if (business.hasNotesForMappers) {
    if (!business.isRejectedMapperNote) {
      // onmy mapper note is added
      icon = VenuePinType.Blue;
    } else {
      // mapper note is added with come latter option
      icon = VenuePinType.Black;
    }
  }
  return icon;
};
